import { processPayrocPayment, savePayrocCard } from 'api/Transaction';

export const chargePayrocPaymentHandler = (
  navigate,
  { surchargeAmount, methodDetail, appliedBalance, ...rest }
) => {
  return processPayrocPayment(navigate, {
    ...rest,
    surcharge: surchargeAmount,
    cardId: methodDetail,
    appliedBalance
  });
};

export const saveCardHandler = (navigate, { ...rest }) => {
  return savePayrocCard(navigate, { ...rest });
};
